<template>
    <div class="primary white--text" :class="dense ? 'mail-avatar-dense' : 'mail-avatar'">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind = "attrs"
                    v-on   = "on"
                >
                    {{ avatar }}
                </div>
            </template>

            <span>{{ sender }}</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: "PIncOutboxAvatar",

    props: {
        sender: {

        },

        dense: {

        }
    },

    computed: {
        avatar () {
            if (!this.sender) {
                return null;
            }

            const tokens = this.sender.split ("@");
            const point  = tokens[0].indexOf(".");

            let avatar = tokens[0].charAt(0);
            if (point > 0) {
                avatar = avatar + tokens[0].charAt(point+1);
            }


            return avatar.toUpperCase();
        }
    }
}
</script>

<style scoped>


.mail-avatar-dense {
    width: 36px;
    height: 36px;
    margin-left: 25px;
    margin-top: 12px;
    border-radius: 50%;
    font-weight: 400;
    text-align: center;
    padding-top: 8px;
    font-size: 14px;
}

.mail-avatar {
    width: 50px;
    height: 50px;
    margin-left: 0;
    margin-top: 0;
    border-radius: 50%;
    font-weight: 400;
    text-align: center;
    padding-top: 12px;
    font-size: 18px;
}

</style>